import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { enumSubscriptionType } from '@app/data-layer/enums/common';
import { SubscriptionModel } from '@app/data-layer/models/common';
import { TranslateService } from '@ngx-translate/core';
import { Observable, ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'organization-plan-info-card',
  templateUrl: './organization-plan-info-card.component.html',
  styleUrls: ['./organization-plan-info-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class OrganizationPlanInfoCardComponent implements OnInit, OnDestroy {
  public enumSubscriptionType: typeof enumSubscriptionType = enumSubscriptionType;
  public subscriptionBenefits: string[];

  private destroy$: ReplaySubject<boolean> = new ReplaySubject();

  @Input() public subscription: SubscriptionModel;

  constructor(private translateService: TranslateService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.getPlanBenefitsTranslations()
      .pipe(takeUntil(this.destroy$))
      .subscribe((benefitsTexts: string[]) => {
        this.subscriptionBenefits = benefitsTexts;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  public get planTypeName(): string {
    const planName = `LABELS.PLAN.${enumSubscriptionType[this.subscription.type]}.NAME`;
    return planName;
  }

  public get planTypeBenefits(): string {
    const planBenefits = `LABELS.PLAN.${enumSubscriptionType[this.subscription.type]}.BENEFITS`;
    return planBenefits;
  }

  public get planTypeDisclaimer(): string {
    const planDisclaimer = `LABELS.PLAN.${enumSubscriptionType[this.subscription.type]}.DISCLAIMER`;
    return planDisclaimer;
  }

  public getPriceConvertedBenefitText(text: string, subscription: SubscriptionModel): string {
    return text.replace(
      '{{priceForItem}}',
      `<span class="organization-plan-info-card__benefit-item__text-highlight">$${subscription.priceForItem}</span>`,
    );
  }

  private getPlanBenefitsTranslations(): Observable<any> {
    return this.translateService.get(this.planTypeBenefits);
  }
}
